<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="450" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm danh
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="pt-4">
          <v-select
            v-model="status"
            :items="attendanceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
            class="mb-4"
          />
          
          <div v-if="isHybrid" class="d-flex align-center">
            <span class="mr-4">Hình thức học:</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  :color="isOnline ? 'success' : 'grey lighten-1'"
                  @click="toggleOnline"
                  size="24"
                  class="transition-swing"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ isOnline ? 'mdi-wifi' : 'mdi-wifi-off' }}
                </v-icon>
              </template>
              <span>{{ isOnline ? 'Online' : 'Offline' }}</span>
            </v-tooltip>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
export default {
  components: {},
  data() {
    return {
      dialog: false,
      status: '',
      attendance: null,
      isOnline: false,
      isHybrid: false
    }
  },
  computed: {
    ...mapState('constant', ['attendanceStatus']),
  },
  methods: {
    ...mapActions({
      updateAttendance: 'lessonAttendance/update',
      fetchAttendances: 'lessonAttendance/fetchAttendances',
      countAttendances: 'lessonAttendance/countAttendances',
    }),
    async save() {
      try {
        this.$loading.active = true
        await this.updateAttendance({
          id: this.attendance.id,
          status: this.status,
          isOnline: this.isOnline
        })
        this.dialog = false
        this.$emit('refresh')
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.$loading.active = false
      }
    },
    openDialog(item) {
      this.status = item.status
      this.attendance = item
      this.isHybrid = get(item, 'class.metadata.classMode') === 'hybrid'
      this.isOnline = item.isOnline
      this.dialog = true
    },
    cancel() {
      this.dialog = false
    },
    toggleOnline() {
      this.isOnline = !this.isOnline
    }
  },

  watch: {},
}
</script>
